document.addEventListener("DOMContentLoaded", function () {

    if (!(document.body.classList.contains("collection") || document.body.classList.contains("default-page"))) return;

    var products = document.querySelectorAll(".grid__item");
    if (!products.length) return;

    var viewedProducts = new Set();

    // Detect platform
    var isMobile = window.matchMedia("(max-width: 768px)").matches;
    var platform = isMobile ? "m-web" : "d-web";

    var batchSize = isMobile ? 2 : 4; // adjust if 6 per row
  
    var observer = new IntersectionObserver(function (entries) {

        var batchItems = [];

        entries.forEach(function (entry) {

        if (!entry.isIntersecting) return;

        var el = entry.target;

        var productId = el.dataset.id;
        
        if (!productId || viewedProducts.has(productId)) return;

        viewedProducts.add(productId);

        // Extract inner data
        var typeEl = el.querySelector(".product-type");
        var sizeEl = el.querySelector(".product-size");
        var priceEl = el.querySelector(".price-item--regular .money");
        var priceRaw = priceEl ? priceEl.getAttribute("original_price") : 0;
        var price = priceRaw ? parseFloat(priceRaw.replace(/[^0-9.]/g, '')) : 0;
        
        var item = {
            item_id: (typeEl && typeEl.dataset.sku) || productId,
            item_name: el.dataset.title || "",
            affiliation: (typeEl && typeEl.dataset.origin) || "",
            coupon: "NA",
            discount: 0,
            index: parseInt(el.dataset.index) || 0,
            item_brand: "Gemstones For Sale",
            item_category: (typeEl && typeEl.dataset.type) || "",
            item_category2: (typeEl && typeEl.dataset.treatment) || "",
            item_list_id: el.getAttribute("parent-id") || "",
            item_list_name: el.getAttribute("parent-name") || "",
            item_variant: (sizeEl && sizeEl.dataset.size) || "",
            price: price,
            quantity: 1,
            listing_date: (typeEl && typeEl.dataset.publish) || ""
        };

        batchItems.push(item);

        });

        if (!batchItems.length) return;

        // Send in batches (4–6 max)
        while (batchItems.length > 0) {

            var batch = batchItems.splice(0, batchSize);

            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({ ecommerce: null });

            window.dataLayer.push({
                event: "view_item_list_ce",
                page_type: "collection_page",
                platform: platform,
                user_id_event: window.GA_CONTEXT ? GA_CONTEXT.user_id : undefined,
                user_status: window.GA_CONTEXT ? GA_CONTEXT.user_status : "guest",
                ecommerce: {
                currency: "USD",
                items: batch
                }
            });

        }

    }, {
        threshold: 0.5
    });

    products.forEach(function (product) {
        observer.observe(product);
    });

});

// open single product page through link
document.addEventListener("DOMContentLoaded", function () {

    var productLinks = document.querySelectorAll(".product--link");
    if (!productLinks.length) return;

    // Detect platform
    var isMobile = window.matchMedia("(max-width: 768px)").matches;
    var platform = isMobile ? "m-web" : "d-web";

    productLinks.forEach(function (link) {

        link.addEventListener("click", function (e) {

            var el = link.closest(".grid__item");
            if (!el) return;

            e.preventDefault();


            var typeEl = el.querySelector(".product-type");
            var sizeEl = el.querySelector(".product-size");
            var listing_date = (typeEl && typeEl.dataset.publish) || "";
            var priceEl = el.querySelector(".price-item--regular .money");
            var priceRaw = priceEl ? priceEl.getAttribute("original_price") : 0;
            var price = priceRaw ? parseFloat(priceRaw.replace(/[^0-9.]/g, '')) : 0;

            var item = {
                item_id: (typeEl && typeEl.dataset.sku) || el.dataset.id,
                item_name: el.dataset.title || "",
                affiliation: (typeEl && typeEl.dataset.origin) || "",
                coupon: "NA",
                discount: 0,
                index: parseInt(el.dataset.index) || 0,
                item_brand: "Gemstones For Sale",
                item_category: (typeEl && typeEl.dataset.type) || "",
                item_category2: (typeEl && typeEl.dataset.treatment) || "",
                item_list_id: el.getAttribute("parent-id") || "",
                item_list_name: el.getAttribute("parent-name") || "",
                item_variant: (sizeEl && sizeEl.dataset.size) || "",
                price: price,
                quantity: 1,
                listing_date : listing_date
            };

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });

            window.dataLayer.push({
                event: "select_item_ce",
                page_type: "collection_page",
                platform: platform,
                user_id_event: window.GA_CONTEXT ? GA_CONTEXT.user_id : undefined,
                user_status: window.GA_CONTEXT ? GA_CONTEXT.user_status : "guest",
                ecommerce: {
                currency: "USD",
                items: [item]
                }
            });

            // Delay navigation slightly to ensure event fires
            setTimeout(function () {
                window.location.href = link.href;
            }, 150);

        });

    });

});

// ADD TO CART - ProductList
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {

    form.addEventListener('submit', function () {

      setTimeout(function () {

      var el = form.closest('.grid__item');
        if (!el) {
          console.warn('No .grid__item found');
          return;
        }

        var typeEl = el.querySelector(".product--info");
        var sizeEl = el.querySelector(".product-size");
        var priceEl = el.querySelector(".price-item--regular .money");
        var priceRaw = priceEl ? priceEl.getAttribute("original_price") : 0;
        var price = priceRaw ? parseFloat(priceRaw.replace(/[^0-9.]/g, '')) : 0;

        // Detect platform
        var isMobile = window.matchMedia("(max-width: 768px)").matches;
        var platform = isMobile ? "m-web" : "d-web";

        var item = {
          item_id: (typeEl && typeEl.dataset.sku) || el.dataset.id || variantId,
          item_name: el.dataset.title || "",
          index: parseInt(el.dataset.index) || 0,
          affiliation: (typeEl && typeEl.dataset.origin) || "",
          item_category: (typeEl && typeEl.dataset.type) || "",
          item_category2: (typeEl && typeEl.dataset.treatment) || "",
          item_variant: (sizeEl && sizeEl.dataset.size) || "",
          item_list_id: el.getAttribute("parent-id") || "",
          item_list_name: el.getAttribute("parent-name") || "",
          price: parseInt(typeEl && typeEl.dataset.price || 0, 10),
          quantity: 1,
          item_brand: "Gemstones For Sale",
          coupon:"NA",
          listing_date : (typeEl && typeEl.dataset.publish) || "",
          discount : 0,
        };

        var value = item.price;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });

        window.dataLayer.push({
          event: 'add_to_cart_ce',
          page_type: "collection_page",
          platform: platform,
          user_id_event: window.GA_CONTEXT?.user_id,
          user_status: window.GA_CONTEXT?.user_status || "guest",
          ecommerce: {
            currency: "USD",
            value: value,
            items: [item]
          }
        });

        //console.log('GA4 add_to_cart (DOM based):', item);

        // ── NEW: publish custom event so CE pixel can receive it ──
        if (window.Shopify?.analytics?.publish) {
          const publishPayload = {
            item_list_id: item.item_list_id,
            item_list_name: item.item_list_name,
            item_category2: item.item_category2,
            affiliation: item.affiliation,
            listing_date: item.listing_date,
            index: item.index
          };

          console.log("[DEV] Publishing ga4_product_context with:", publishPayload);
          window.Shopify.analytics.publish('ga4_product_context', publishPayload);
        }

      }, 200); // slight delay to allow form processing
      

    });

  });

});


// modal - quickview - addtocart
(function () {

  var originalFetch = window.fetch;

  window.fetch = function () {

    return originalFetch.apply(this, arguments).then(function (response) {

      // Only track add-to-cart API
      if (!response.url.includes('/cart/add')) return response;
      response.clone().json().then(function (cartData) {

        try {

          // Find active quickview or fallback to document
          var container = document.querySelector('.quickview-full-content');
          if (!container) return;
          var productInfo = container.querySelector('.product--info');
        /*  var priceEl = container.querySelector("span.money");
          var priceRaw = priceEl ? priceEl.getAttribute("original_price") : 0;
          var price = priceRaw ? parseFloat(priceRaw.replace(/[^0-9.]/g, '')) : 0;*/

          if (!productInfo) return;

          // Extract custom data
          var productId = productInfo.dataset.id;
          var productTitle = productInfo.dataset.title;
          var productType = productInfo.dataset.type;
          var sku = productInfo.dataset.sku;
          var origin = productInfo.dataset.origin;
          var treatment = productInfo.dataset.treatment;
          var price = parseInt(productInfo.dataset.price || 0, 10);

          // Collection from URL
          var pathParts = window.location.pathname.split('/');
          var parentCollection = (pathParts[1] === "collections") ? pathParts[2] : "";

          // Platform detect
          var isMobile = window.matchMedia("(max-width: 768px)").matches;
          var platform = isMobile ? "m-web" : "d-web";

          var item = {
            item_id: productId,
            item_name: productTitle,
            affiliation: origin,
            item_category: productType,
            item_category2: treatment,
            item_variant: sku,
            item_list_id: parentCollection || "",
            item_list_name: parentCollection || "",
            price: price,
            quantity: 1,
            item_brand: "Gemstones For Sale",
            coupon:"NA",
            listing_date : (productInfo && productInfo.dataset.publish) || "",
            discount : 0,
            index:1
          };

          // Push to dataLayer
          window.dataLayer = window.dataLayer || [];

          window.dataLayer.push({
            event: "add_to_cart_ce",
            page_type: window.GA_CONTEXT?.page_type || "",
            platform: platform,
            user_id_event: window.GA_CONTEXT?.user_id,
            user_status: window.GA_CONTEXT?.user_status,
            ecommerce: {
              currency: "USD",
              value: price,
              items: [item]
            }
          });

          // ── NEW: publish custom event so CE pixel can receive it ──
          if (window.Shopify?.analytics?.publish) {
            const publishPayload = {
              item_list_id: item.item_list_id,
              item_list_name: item.item_list_name,
              item_category2: item.item_category2,
              affiliation: item.affiliation,
              listing_date: item.listing_date,
              index: item.index
            };

            console.log("[DEV] Publishing ga4_product_context with:", publishPayload);
            window.Shopify.analytics.publish('ga4_product_context', publishPayload);
          }

        } catch (err) {
          console.error("GTM AddToCart Error:", err);
        }

      });

      return response;

    });

  };

})();